import getApiClient from './../../../../plugins/api'

export default {
    send: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.error = ''

        if (! self.password) {
            self.error = 'Informe a nova senha'
            return
        }

        if (self.password !== self.passwordConfirmation) {
            self.error = 'A confirmação da senha não bate com a senha informada'
            return
        }

        let postData = {
            password: self.password,
            token: self.token['@id']
        }

        self.$store.commit('startLoading')
        api.patch(`/users/reset_password/${self.token.user.id}`, postData, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(() => {
                self.message = 'Senha alterada com sucesso!'
            })
            .catch(() => {
                self.error = 'Ocorreu um erro ao processar sua solicitação. Tente novamente mais tarde.'
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })

    }
}
